export interface FileTypes {
  CARD_PRODUCTION: {
    ARTWORK: string;
    ASN: string;
    PROOF_OF_PAYMENT: string;
    EXTERNAL_PIN: string;
    PO_SOW: string;
  };
  CARD_DESIGN: {
    ART: string;
    ARTWORK: string;
  };
  DEFAULT: string;
  DEFAULT_DESIGN: string;
  POP_DESIGN: {
    ART: string;
    ARTWORK: string;
    FS_FILE: string;
  };
  POP_PRODUCTION: {
    ARTWORK: string;
    ASN: string;
    OTHER: string;
    PARTNER_ART: string;
    PRINTER_PROOF: string;
    PRINTER_QUOTE: string;
  };
  FINANCIAL_SERVICES: {
    ARTWORK: string;
    ASN: string;
    FINANCE: string;
  };
  BIF_PRODUCTION: {
    FINANCE: string;
    ARTWORK: string;
    PRINTER_PROOF: string;
    ASN: string;
    MATRIX: string;
  };
  THIRD_PARTY_PRODUCTION: {
    FINANCE: string;
    ARTWORK: string;
    OPS: string;
    ASN: string;
    PO_SOW: string;
    EXTERNAL_PIN: string;
  };
  IH_PRODUCTION: {
    ARTWORK: string;
    PRINTER_PROOF: string;
    MATRIX: string;
  };
  IMAGE: {
    ART_FILE: string;
  };
}

export const FILE_TYPES: FileTypes = {
  CARD_PRODUCTION: {
    ARTWORK: 'card-production-artwork',
    ASN: 'card-production-asn',
    PROOF_OF_PAYMENT: 'card-production-finances',
    EXTERNAL_PIN: 'card-production-external-pin',
    PO_SOW: 'card-production-po-sow',
  },
  CARD_DESIGN: {
    ART: 'card-design-art-file',
    ARTWORK: 'card-design-artwork-file'
  },
  POP_DESIGN: {
    ART: 'pop-design-art-file',
    ARTWORK: 'pop-design-artwork-file',
    FS_FILE: 'pop-design-fs-review-file'
  },
  POP_PRODUCTION: {
    ARTWORK: 'pop-production-artwork',
    ASN: 'pop-production-asn',
    OTHER: 'pop-production-other',
    PARTNER_ART: 'pop-production-partner-art',
    PRINTER_PROOF: 'pop-production-printer-proof',
    PRINTER_QUOTE: 'pop-production-printer-quote'
  },
  FINANCIAL_SERVICES: {
    ARTWORK: 'financial-services-artwork',
    ASN: 'financial-services-asn',
    FINANCE: 'financial-services-finance',
  },
  BIF_PRODUCTION: {
    FINANCE: 'bif-production-finance',
    ARTWORK: 'bif-production-artwork',
    PRINTER_PROOF: 'bif-production-printer-proof',
    ASN: 'bif-production-asn',
    MATRIX: 'bif-production-matrix'
  },
  THIRD_PARTY_PRODUCTION: {
    FINANCE: 'third-party-production-finance',
    ARTWORK: 'third-party-production-artwork',
    OPS: 'third-party-production-ops',
    ASN: 'third-party-production-asn',
    PO_SOW: 'third-party-production-po-sow',
    EXTERNAL_PIN: 'third-party-production-external-pin'
  },
  IMAGE: {
    ART_FILE: 'image-art-file',
  },
  IH_PRODUCTION: {
    ARTWORK: 'ih-production-artwork',
    PRINTER_PROOF: 'ih-production-printer-proof',
    MATRIX: 'ih-production-matrix'
  },
  DEFAULT: 'default',
  DEFAULT_DESIGN: 'default.design'
};
